import { useEffect, useState } from 'react'

export function useTabGuard() {
  const [multiTab, setMultiTab] = useState(false)

  useEffect(() => {
    const ch = new BroadcastChannel('ggram_tab')
    ch.postMessage('hello')

    const handler = (e: MessageEvent) => {
      if (e.data === 'hello') {
        setMultiTab(true)
        ch.postMessage('taken') // reply that tab is already taken
      }
      if (e.data === 'taken') setMultiTab(true)
    }
    ch.addEventListener('message', handler)

    return () => {
      ch.close()
    }
  }, [])

  return multiTab
}
